import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Paper, Typography, Box } from '@material-ui/core';

const DashboardPieChart = ({ title, data, colors = [] }) => {
    const options = {
        chart: {
            type: 'pie',
            backgroundColor: 'transparent',
            height: 300,
            style: {
                fontFamily: 'Prompt, sans-serif'
            }
        },
        title: {
            text: null
        },
        tooltip: {
            pointFormat: '<b>{point.y}</b> คน ({point.percentage:.1f}%)'
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                colors: colors.length > 0 ? colors : undefined,
                dataLabels: {
                    enabled: true,
                    format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                    style: {
                        fontSize: '12px',
                        fontWeight: 'normal',
                        color: '#666'
                    }
                },
                showInLegend: true
            }
        },
        credits: { enabled: false },
        series: [{
            name: 'Admins',
            colorByPoint: true,
            innerSize: '50%', // Makes it a donut chart
            data: data
        }]
    };

    return (
        <Paper className="h-full p-6 rounded-xl overflow-hidden" elevation={3} style={{ borderRadius: '16px' }}>
            <Typography variant="h6" className="font-bold text-gray-800 mb-4 text-center">
                {title}
            </Typography>
            <Box className="flex justify-center items-center h-full">
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options}
                />
            </Box>
        </Paper>
    );
};

export default DashboardPieChart;
